import darkLogo from '../../logo/retax360-logo-dark.svg?raw';
import lightLogo from '../../logo/retax360-logo-light.svg?raw';
import markLogo from '../../logo/retax360-mark.svg?raw';

type LogoBackground = 'light' | 'dark';

/** Exact supplied SVGs. Every theme currently uses the Aurora artwork. */
const LOGOS: Readonly<Record<LogoBackground, { full: string; mark: string }>> = {
  light: { full: lightLogo, mark: markLogo },
  dark: { full: darkLogo, mark: markLogo },
};

let instanceCount = 0;

/** Inline logo for a light or dark background. SVG ids are made unique per instance. */
export function logo(background: LogoBackground, markOnly = false): string {
  const n = ++instanceCount;
  const svg = (markOnly ? LOGOS[background].mark : LOGOS[background].full)
    .trim()
    .replace(/id="([^"]+)"/g, `id="$1-${n}"`)
    .replace(/url\(#([^)]+)\)/g, `url(#$1-${n})`);
  return svg.replace(
    '<svg',
    markOnly ? '<svg aria-hidden="true" focusable="false"' : '<svg role="img" aria-label="ReTax360"',
  );
}
